import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatWindowError.css';

type TProps = {
  text: string;
  onRetry?: () => void;
};

export const ChatWindowError: React.FC<TProps> = ({ text, onRetry }) => {
  return (
    <div className={styles['container']} data-testid="ChatMessageRetry">
      <UIText2 color="white_100">{text}</UIText2>
      {onRetry ? (
        <button className={styles['button']} type="button" onClick={onRetry}>
          <UIText2 color="white_100" fontWeight="bold">
            Повторить
          </UIText2>
        </button>
      ) : null}
    </div>
  );
};
